import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "list--sprite",
  "use": "list--sprite-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"list--sprite\">\n    <g fill-rule=\"evenodd\">\n        <path d=\"M.375 4.5L10.875 4.5M.375.75L10.875.75M.375 8.25L10.875 8.25\" transform=\"translate(7.5 7.5)\" />\n        <circle fill=\"none\" cx=\"6.375\" cy=\"8.25\" r=\"1.125\" />\n        <circle fill=\"none\" cx=\"6.375\" cy=\"12\" r=\"1.125\" />\n        <circle fill=\"none\" cx=\"6.375\" cy=\"15.75\" r=\"1.125\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol